module.exports = __webpack_public_path__ + "img/hydrocodone.d50d9c1f.png";